import React from 'react';
const handlePurchaseClick = () => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Cría con calma - Header CTA',
        content_category: 'Parenting Guide',
        value: 7.99,
        currency: 'USD'
      });
      console.log('✅ InitiateCheckout tracked from Header');
    }
  } catch (error) {
    console.error('❌ Error tracking purchase click:', error);
  }
};
export function Header() {
  return <header className="w-full bg-white/90 backdrop-blur-sm sticky top-0 z-50 border-b border-amber-100" data-id="element-242">
      <div className="container mx-auto flex justify-between items-center py-2 px-3 md:px-6 md:py-4" data-id="element-243">
        <div className="flex items-center" data-id="element-244">
          <h1 className="text-amber-800 font-serif text-sm md:text-xl font-bold whitespace-nowrap" data-id="element-245">
            Deja de gritar
          </h1>
        </div>
        <a href="https://pay.hotmart.com/E103092077E" onClick={handlePurchaseClick} data-id="element-246">
          <button className="bg-amber-700 hover:bg-amber-800 text-white font-medium text-xs md:text-sm py-1.5 px-2 md:py-2 md:px-4 rounded-md whitespace-nowrap" data-id="element-247">
            Comprar - $7.99
          </button>
        </a>
      </div>
    </header>;
}